<!-- Header -->
<ion-header
  class="ion-no-border"
  [class.ion-header-modal-desktop]="platformType === platformEnum.desktop"
  [class.ion-header-modal-tablet]="platformType === platformEnum.tablet"
  [class.ion-header-modal-mobile]="platformType === platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons *ngIf="platformType === platformEnum.desktop" slot="end">
      <ion-button
        data-cy="inventory-item-modal-close-button"
        (click)="dismissModal()"
      >
        <ion-icon
          data-cy="inventory-item-modal-close-button-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      data-cy="inventory-item-modal-title"
      *ngIf="!inventoryItemModalOptions.nonUSFFlag"
    >
      {{
        'i18n.inventory.inventoryWorksheet.inventoryItemModal.productDetails'
          | translate
      }}
    </ion-label>
    <ion-label
      data-cy="inventory-item-modal-title"
      *ngIf="inventoryItemModalOptions.nonUSFFlag"
    >
      {{
        'i18n.inventory.inventoryWorksheet.inventoryItemModal.nonUsfProductDetails'
          | translate
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="inventory-item-modal_content"
  [class.ion-content-modal-desktop]="platformType === platformEnum.desktop"
  [class.ion-content-modal-tablet]="platformType === platformEnum.tablet"
  [class.ion-content-modal-mobile]="platformType === platformEnum.mobile"
  tabletTouchMove
>
  <ion-grid
    [style.margin-bottom]="onFocus && isAndroidTouch ? '25rem' : null"
    [fixed]="true"
  >
    <!-- Product Info -->
    <ion-row
      data-cy="inventory-item-modal-product-info-row"
      class="product-info-row"
    >
      <!-- Product Thumbnail -->
      <ion-col
        data-cy="inventory-item-modal-product-info-left-column"
        class="product-info-left-col ion-margin-end"
      >
        <img
          *ngIf="
            !!inventoryItemModalOptions?.imageThumbnail;
            else noImageThumbnail
          "
          [attr.data-cy]="
            'inventory-item-modal-product-' +
            inventoryItemModalOptions?.productNumber +
            '-image'
          "
          class="product-img"
          src="{{ inventoryItemModalOptions?.imageThumbnail }}"
        />
        <ng-template #noImageThumbnail>
          <ion-icon
            data-cy="inventory-item-modal-product-no-image-icon"
            class="product-img no-image"
            name="restaurant"
          ></ion-icon>
        </ng-template>
      </ion-col>
      <!-- Product Brand, Description, Number, Sales Pack Size -->
      <ion-col
        data-cy="inventory-item-modal-product-info-right-column"
        class="product-info-right-col"
      >
        <div
          data-cy="inventory-item-modal-brand-text"
          class="brand"
          *ngIf="inventoryItemModalOptions.nonUSFFlag"
        >
          {{
            inventoryItemModalOptions.brand !== ''
              ? (inventoryItemModalOptions?.brand || ' ' | acronymTitleCase)
              : ('i18n.inventory.inventoryWorksheet.inventoryItemModal.missingBrand'
                | translate)
          }}
        </div>
        <div
          data-cy="inventory-item-modal-brand-text"
          class="brand"
          *ngIf="!inventoryItemModalOptions.nonUSFFlag"
        >
          {{ inventoryItemModalOptions?.brand || ' ' | acronymTitleCase }}
        </div>
        <div
          data-cy="inventory-item-modal-description-text"
          class="description"
        >
          {{ inventoryItemModalOptions?.description || ' ' | acronymTitleCase }}
        </div>
        <div
          data-cy="inventory-item-modal-number-packsize-section"
          class="product-number-sales-pack-size"
          *ngIf="
            platformType !== platformEnum.mobile ||
            !inventoryItemModalOptions.nonUSFFlag
          "
        >
          <p data-cy="inventory-item-modal-number-text" class="product-number">
            <span *ngIf="inventoryItemModalOptions.nonUSFFlag">P#: </span
            ><span *ngIf="!inventoryItemModalOptions.nonUSFFlag">#</span
            >{{ inventoryItemModalOptions?.productNumber }}
          </p>
          <img
            data-cy="inventory-item-modal-number-separator-image"
            class="separator-image"
            src="assets/images/separator.png"
            *ngIf="inventoryItemModalOptions.nonUSFFlag"
          />
          <p
            data-cy="inventory-item-modal-number-text"
            class="product-number"
            *ngIf="inventoryItemModalOptions.nonUSFFlag"
          >
            M#:
            {{
              inventoryItemModalOptions?.manufacturerNumber !== ''
                ? inventoryItemModalOptions?.manufacturerNumber
                : 'N/A'
            }}
          </p>
          <img
            data-cy="inventory-item-modal-number-separator-image"
            class="separator-image"
            src="assets/images/separator.png"
          />
          <p
            data-cy="inventory-item-modal-packsize-text"
            class="sales-pack-size"
            *ngIf="inventoryItemModalOptions.nonUSFFlag"
          >
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.pack'
                | translate
            }}
            {{
              inventoryItemModalOptions?.salesPackSize !== ''
                ? inventoryItemModalOptions?.salesPackSize
                : ('i18n.inventory.inventoryWorksheet.inventoryItemModal.missingPackSize'
                  | translate)
            }}
          </p>
          <p
            data-cy="inventory-item-modal-packsize-text"
            class="sales-pack-size"
            *ngIf="!inventoryItemModalOptions.nonUSFFlag"
          >
            {{ inventoryItemModalOptions?.salesPackSize | translate }}
          </p>
        </div>
        <div
          data-cy="inventory-item-modal-number-packsize-section"
          class="product-number-sales-pack-size mobile"
          *ngIf="
            platformType === platformEnum.mobile &&
            inventoryItemModalOptions.nonUSFFlag
          "
        >
          <div class="product-manufacturer">
            <p
              data-cy="inventory-item-modal-number-text"
              class="product-number"
            >
              P#: {{ inventoryItemModalOptions?.productNumber }}
            </p>

            <img
              data-cy="inventory-item-modal-number-separator-image"
              class="separator-image"
              src="assets/images/separator.png"
            />
            <p
              data-cy="inventory-item-modal-number-text"
              class="product-number"
            >
              M#:
              {{
                inventoryItemModalOptions?.manufacturerNumber !== ''
                  ? inventoryItemModalOptions?.manufacturerNumber
                  : 'N/A'
              }}
            </p>
          </div>

          <div>
            <div>
              <p
                data-cy="inventory-item-modal-packsize-text"
                class="sales-pack-size"
                *ngIf="inventoryItemModalOptions.nonUSFFlag"
              >
                {{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.pack'
                    | translate
                }}
                {{
                  inventoryItemModalOptions?.salesPackSize !== ''
                    ? inventoryItemModalOptions?.salesPackSize
                    : 'N/A'
                }}
              </p>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <!-- PDP Link -->
    <ion-row data-cy="inventory-item-modal-pdp-link-row" class="pdp-link-row">
      <ion-col data-cy="inventory-item-modal-pdp-link-column" size="12">
        <span (click)="openPDPOverlay()">
          {{
            (inventoryItemModalOptions.nonUSFFlag
              ? 'i18n.inventory.inventoryWorksheet.inventoryItemModal.visitNonUsf'
              : 'i18n.inventory.inventoryWorksheet.inventoryItemModal.visitPdp'
            ) | translate
          }}
        </span>
      </ion-col>
    </ion-row>
    <!-- Inventory Value -->
    <ion-row data-cy="inventory-item-modal-value-row" class="value-row">
      <ion-col data-cy="inventory-item-modal-value-column" size="12">
        {{
          'i18n.inventory.inventoryWorksheet.inventoryItemModal.value'
            | translate
        }}
        {{ inventoryItemModalOptions?.value | currency }}
      </ion-col>
    </ion-row>
    <!-- Quantities -->
    <ion-row
      data-cy="inventory-item-modal-quantities-row"
      class="ion-margin-top"
    >
      <ion-col class="qty-col">
        <div data-cy="inventory-item-modal-cases-container" class="qty-section">
          <ion-input
            *ngIf="!inventoryItemModalOptions.catchWeightFlag"
            data-cy="inventory-item-modal-cases-input"
            class="not-applicable-input"
            disabled="true"
            [value]="inventoryItemModalOptions.numberOfCases"
            [class.bad-pricing-border]="
              inventoryItemModalOptions.casePrice === -1
            "
          >
          </ion-input>
          <ion-input
            *ngIf="inventoryItemModalOptions.catchWeightFlag"
            data-cy="inventory-item-modal-cases-input"
            class="not-applicable-input catch-weight-border"
            disabled="true"
            value="N/A"
          >
          </ion-input>
          <span
            *ngIf="
              inventoryItemModalOptions.casePrice !== -1 &&
              !inventoryItemModalOptions.catchWeightFlag
            "
            data-cy="inventory-item-modal-cases-text"
          >
            {{ inventoryItemModalOptions.casePrice | currency }}&nbsp;{{
              'i18n.common.cs' | translate
            }}
          </span>
          <span
            *ngIf="
              inventoryItemModalOptions.casePrice === -1 ||
              inventoryItemModalOptions.catchWeightFlag
            "
            data-cy="inventory-item-modal-cases-text"
          >
            {{ 'i18n.common.notApplicable' | translate }}
          </span>
        </div>
        <div
          data-cy="inventory-item-modal-unit-price-container"
          class="qty-section"
        >
          <ion-input
            data-cy="inventory-item-modal-unit-price-input"
            class="not-applicable-input"
            disabled="true"
            [value]="inventoryItemModalOptions.numberOfUnits"
            [class.bad-pricing-border]="
              inventoryItemModalOptions.unitPrice === -1
            "
          >
          </ion-input>
          <span
            *ngIf="inventoryItemModalOptions.unitPrice !== -1; else naUnit"
            data-cy="inventory-item-modal-unit-price-text"
          >
            {{ inventoryItemModalOptions.unitPrice | currency }}
            {{
              inventoryItemModalOptions.unit === 'Custom'
                ? inventoryItemModalOptions.customUnit
                : inventoryItemModalOptions.unit
            }}
          </span>
          <ng-template #naUnit>
            <span data-cy="inventory-item-modal-unit-price-text">
              {{ 'i18n.common.notApplicable' | translate }}
            </span>
          </ng-template>
        </div>
      </ion-col>
    </ion-row>
    <!-- Modal Options -->
    <ion-row
      data-cy="inventory-item-modal-options-row"
      class="bottom-container"
    >
      <!-- Left Side -->
      <ion-col
        *ngIf="
          (platformType === platformEnum.mobile &&
            !inventoryItemModalOptions.selectedOption) ||
          platformType !== platformEnum.mobile
        "
        data-cy="inventory-item-modal-options-left-column"
        size-xl="5.5"
        size-lg="5.5"
        size-md="5.5"
        size-sm="12"
        size-xs="12"
        class="left-container"
      >
        <!-- Choose Group -->
        <ion-item
          data-cy="inventory-item-modal-choose-group-button"
          class="selectable-item"
          [class.selected]="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.chooseGroup
          "
          detail="true"
          (click)="selectOption(inventoryItemEditOptions.chooseGroup)"
        >
          <ion-label data-cy="inventory-item-modal-choose-group-button-label">
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.chooseGroup'
                | translate
            }}
            <span data-cy="inventory-item-modal-choose-group-button-sublabel">
              {{ inventoryItemModalOptions.selectedGroup.groupName }}
            </span>
          </ion-label>
        </ion-item>
        <!-- Choose Position -->
        <ion-item
          data-cy="inventory-item-modal-choose-position-button"
          class="selectable-item"
          [class.selected]="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.choosePosition
          "
          detail="true"
          (click)="selectOption(inventoryItemEditOptions.choosePosition)"
        >
          <ion-label
            data-cy="inventory-item-modal-choose-position-button-label"
          >
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.choosePosition'
                | translate
            }}
            <span
              data-cy="inventory-item-modal-choose-position-button-sublabel"
            >
              {{ inventoryItemModalOptions.selectedPosition }}
            </span>
          </ion-label>
        </ion-item>
        <!-- Inventory Unit -->
        <ion-item
          data-cy="inventory-item-modal-unit-button"
          class="selectable-item"
          [class.selected]="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.inventoryUnit
          "
          detail="true"
          (click)="selectOption(inventoryItemEditOptions.inventoryUnit)"
        >
          <ion-label data-cy="inventory-item-modal-unit-button-label">
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.inventoryUnit'
                | translate
            }}
            <span data-cy="inventory-item-modal-unit-button-sublabel">
              {{
                inventoryItemModalOptions.unit === 'Custom'
                  ? inventoryItemModalOptions.customUnit
                  : inventoryItemModalOptions.unit
              }}
            </span>
          </ion-label>
        </ion-item>
        <!-- Price -->
        <ion-item
          data-cy="inventory-item-modal-price-button"
          class="selectable-item"
          [class.selected]="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.price
          "
          detail="true"
          (click)="selectOption(inventoryItemEditOptions.price)"
        >
          <ion-label data-cy="inventory-item-modal-price-button-label">
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.price'
                | translate
            }}
            <span
              *ngIf="
                !inventoryItemModalOptions.catchWeightFlag;
                else catchWeightPrice
              "
              data-cy="inventory-item-modal-price-button-sublabel"
            >
              {{
                inventoryItemModalOptions.priceOverrideInd === 'Y'
                  ? (inventoryItemModalOptions.overrideCasePrice | currency)
                  : inventoryItemModalOptions.casePrice === -1
                    ? 'N/A'
                    : (inventoryItemModalOptions.casePrice | currency)
              }}
              <span
                *ngIf="inventoryItemModalOptions.casePrice !== -1"
                data-cy="inventory-item-modal-price-button-sublabel-cs"
              >
                / {{ 'i18n.common.cs' | translate }}
              </span>
            </span>
            <ng-template #catchWeightPrice>
              <span data-cy="inventory-item-modal-price-button-sublabel">
                {{
                  inventoryItemModalOptions.priceOverrideInd === 'Y'
                    ? (inventoryItemModalOptions.overrideCasePrice | currency)
                    : inventoryItemModalOptions.unitPrice === -1
                      ? 'N/A'
                      : (inventoryItemModalOptions.unitPrice | currency)
                }}
                <span
                  *ngIf="inventoryItemModalOptions.unitPrice !== -1"
                  data-cy="inventory-item-modal-price-button-sublabel-lb"
                >
                  /
                  {{ 'i18n.inventory.inventoryWorksheet.card.lb' | translate }}
                </span>
              </span>
            </ng-template>
          </ion-label>
        </ion-item>
      </ion-col>
      <!-- Right Side -->
      <ion-col
        *ngIf="
          (platformType === platformEnum.mobile &&
            inventoryItemModalOptions.selectedOption) ||
          platformType !== platformEnum.mobile
        "
        data-cy="inventory-item-modal-options-right-column"
        size-xl="5.5"
        size-lg="5.5"
        size-md="5.5"
        offset-xl="1"
        offset-lg="1"
        offset-md="1"
        size-sm="12"
        size-xs="12"
        class="right-container"
      >
        <div
          *ngIf="platformType === platformEnum.mobile"
          class="selected-option-title-mobile"
        >
          <ion-icon
            (click)="selectOption('')"
            name="chevron-back-outline"
          ></ion-icon>
          <ion-label>
            {{ inventoryItemModalOptions.selectedOption }}
          </ion-label>
        </div>
        <!-- Group Options -->
        <div
          *ngIf="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.chooseGroup
          "
          data-cy="inventory-item-modal-choose-group-section"
          class="select-group"
        >
          <p
            data-cy="inventory-item-modal-choose-group-guideline-text"
            class="action-small-text"
          >
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.selectGroupForItem'
                | translate
            }}
          </p>
          <ion-radio-group
            data-cy="inventory-item-modal-choose-group-options"
            [value]="inventoryItemModalOptions.selectedGroup.groupName"
          >
            <ion-list data-cy="inventory-item-modal-choose-group-options-list">
              <ion-item
                *ngFor="
                  let group of inventoryItemModalOptions.groups;
                  let i = index
                "
                [attr.data-cy]="'inventory-item-modal-group-option-' + i"
                class="selectable-item"
                (click)="selectGroup(group)"
              >
                <ion-label
                  id="inventory-item-group-option"
                  [attr.data-cy]="'inventory-item-modal-group-option-text-' + i"
                >
                  {{ group?.groupName }}
                </ion-label>
                <ion-radio
                  aria-labelledby="inventory-item-group-option"
                  [attr.data-cy]="
                    'inventory-item-modal-group-option-radio-button-' + i
                  "
                  mode="md"
                  slot="end"
                  value="{{ group.groupName }}"
                ></ion-radio>
              </ion-item>
            </ion-list>
          </ion-radio-group>
        </div>
        <!-- Position Options -->
        <div
          *ngIf="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.choosePosition
          "
          data-cy="inventory-item-modal-choose-position-section"
        >
          <p
            data-cy="inventory-item-modal-choose-position-guideline-text"
            class="action-small-text"
          >
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.selectPositionForItem'
                | translate
            }}
          </p>
          <ion-radio-group
            data-cy="inventory-item-modal-choose-position-options"
            [value]="inventoryItemModalOptions.selectedPosition"
          >
            <ion-item
              data-cy="inventory-item-modal-top-option"
              class="selectable-item"
              (click)="selectPosition(groupPosition.top)"
            >
              <ion-label
                id="inventory-item-option"
                data-cy="inventory-item-modal-top-option-text"
              >
                {{ groupPosition.top }}
              </ion-label>
              <ion-radio
                aria-labelledby="inventory-item-option"
                data-cy="inventory-item-modal-top-option-radio-button"
                mode="md"
                slot="end"
                value="{{ groupPosition.top }}"
              ></ion-radio>
            </ion-item>
            <ion-item
              data-cy="inventory-item-modal-bottom-option"
              class="selectable-item"
              (click)="selectPosition(groupPosition.bottom)"
            >
              <ion-label
                id="inventory-item-bottom-option"
                data-cy="inventory-item-modal-bottom-option-text"
              >
                {{ groupPosition.bottom }}
              </ion-label>
              <ion-radio
                aria-labelledby="inventory-item-bottom-option"
                data-cy="inventory-item-modal-bottom-option-radio-button"
                mode="md"
                slot="end"
                value="{{ groupPosition.bottom }}"
              ></ion-radio>
            </ion-item>
          </ion-radio-group>
        </div>
        <!-- Inventory Unit Options -->
        <div
          *ngIf="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.inventoryUnit
          "
          data-cy="inventory-item-modal-choose-unit-section"
          class="select-unit"
        >
          <span
            data-cy="inventory-item-modal-choose-unit-guideline-text"
            class="action-regular-text"
          >
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.useFields'
                | translate
            }}
          </span>
          <div
            *ngIf="inventoryItemModalOptions.catchWeightFlag"
            class="catch-weight-note"
          >
            <b>{{ 'i18n.common.note' | translate }}</b>
            {{ 'i18n.inventory.catchWeightNote' | translate }}
          </div>
          <div
            data-cy="inventory-item-modal-choose-unit-options"
            class="unit-container"
          >
            <!-- Inventory Unit -->
            <div
              data-cy="inventory-item-modal-unit-option-section"
              class="unit-container-section"
            >
              <span
                data-cy="inventory-item-modal-unit-option-text"
                class="action-regular-text"
              >
                {{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.inventoryUnit'
                    | translate
                }}
              </span>
              <ion-item
                data-cy="inventory-item-modal-unit-option"
                class="input-item"
                button
                detail="true"
                detail-icon="chevron-down-outline"
                mode="ios"
                (click)="openUnitPopover($event)"
              >
                <ion-label data-cy="inventory-item-modal-unit-option-label">
                  {{ inventoryItemModalOptions?.unit }}
                </ion-label>
              </ion-item>
            </div>
            <!-- Inventory Unit/Full -->
            <div
              data-cy="inventory-item-modal-unit-full-option-section"
              class="unit-container-section"
              *ngIf="!inventoryItemModalOptions.catchWeightFlag"
            >
              <span
                data-cy="inventory-item-modal-unit-full-option-text"
                class="action-regular-text"
              >
                {{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.inventoryUnitFull'
                    | translate
                }}
              </span>
              <ion-item
                *ngIf="
                  !inventoryItemModalOptions.catchWeightFlag;
                  else catchWeightPriceInput
                "
                data-cy="inventory-item-modal-unit-full-option"
                class="input-item"
                lines="none"
                mode="ios"
              >
                <ion-input
                  data-cy="inventory-item-modal-unit-full-option-input"
                  maxlength="5"
                  min="0"
                  mode="ios"
                  type="text"
                  [maxLeftHandDigits]="4"
                  [maxPrecision]="2"
                  customDecimal
                  [value]="inventoryItemModalOptions.invConvFactor"
                  (ionChange)="changeInvConvFactor($event)"
                  (ionBlur)="inputBlur()"
                  (ionFocus)="inputFocus()"
                ></ion-input>
              </ion-item>
              <ng-template #catchWeightPriceInput>
                <ion-item
                  data-cy="inventory-item-modal-unit-full-option"
                  class="input-item not-applicable-input-item"
                  lines="none"
                  mode="ios"
                >
                  <ion-input
                    data-cy="inventory-item-modal-unit-full-option-input"
                    class="not-applicable-input"
                    disabled="true"
                    placeholder="{{ 'i18n.common.notApplicable' | translate }}"
                  ></ion-input>
                </ion-item>
              </ng-template>
            </div>
          </div>
          <!-- Inventory Custom -->
          <div
            *ngIf="inventoryItemModalOptions.unit === 'Custom'"
            data-cy="inventory-item-modal-custom-unit-option-section"
            class="custom-unit-container"
          >
            <div
              data-cy="inventory-item-modal-custom-unit-option-section-inner"
              class="unit-container-section"
            >
              <ion-item
                data-cy="inventory-item-modal-custom-unit-option"
                class="input-item"
                lines="none"
                mode="ios"
                [class.error-highlight]="
                  inventoryItemModalOptions.customErrorFlag
                "
              >
                <ion-input
                  data-cy="inventory-item-modal-custom-unit-input"
                  maxlengthAndroid
                  [max]="8"
                  min="0"
                  mode="ios"
                  type="text"
                  placeholder="{{
                    'i18n.inventory.inventoryWorksheet.inventoryItemModal.custom'
                      | translate
                  }}"
                  alphanumericExceptAndroid
                  (ionChange)="changeCustomUnit($event)"
                  (ionBlur)="inputBlur()"
                  (ionFocus)="inputFocus()"
                  [formControl]="customUnitInput"
                ></ion-input
                ><span *ngIf="customUnitInput.errors?.pattern" slot="error">{{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.specialCharacters'
                    | translate
                }}</span>
                <span
                  *ngIf="
                    customUnitInput.errors?.maxlength &&
                    !customUnitInput.errors?.pattern
                  "
                  slot="error"
                  >{{
                    'i18n.inventory.inventoryWorksheet.inventoryItemModal.customUnitMaxLength'
                      | translate
                  }}</span
                >
              </ion-item>
              <p
                class="custom-error"
                *ngIf="
                  inventoryItemModalOptions.unit === 'Custom' &&
                  inventoryItemModalOptions.customErrorFlag
                "
              >
                {{
                  'i18n.inventory.inventoryWorksheet.inventoryCustomModal.uniqueError'
                    | translate
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- Inventory Price Options -->
        <div
          *ngIf="
            inventoryItemModalOptions.selectedOption ===
            inventoryItemEditOptions.price
          "
          data-cy="inventory-item-modal-choose-price-section"
          class="select-price"
        >
          <span
            data-cy="inventory-item-modal-choose-price-guideline-text"
            class="action-regular-text"
          >
            {{
              'i18n.inventory.inventoryWorksheet.inventoryItemModal.adjustPricing'
                | translate
            }}
          </span>
          <div
            data-cy="inventory-item-modal-choose-price-options"
            class="price-container"
          >
            <ion-item
              data-cy="inventory-item-modal-price-override-toggle-section"
              class="toggle-item"
              mode="ios"
              lines="none"
            >
              <ion-label
                id="price-override"
                data-cy="inventory-item-modal-price-override-toggle-text"
                class="action-regular-text price-override-text"
              >
                {{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.priceOverride'
                    | translate
                }}
              </ion-label>
              <ion-toggle
                aria-labelledby="price-override"
                data-cy="inventory-item-modal-price-override-toggle"
                mode="ios"
                slot="end"
                [checked]="inventoryItemModalOptions.priceOverrideInd === 'Y'"
                (ionChange)="changePriceOverrideInd($event)"
              ></ion-toggle>
            </ion-item>
            <ion-item
              *ngIf="inventoryItemModalOptions.priceOverrideInd === 'Y'"
              data-cy="inventory-item-modal-price-override-input-section"
              class="input-item"
              mode="ios"
              lines="none"
            >
              <ion-input
                data-cy="inventory-item-modal-price-override-input"
                mode="ios"
                placeholder="No price"
                type="text"
                customDecimal
                [maxLeftHandDigits]="6"
                [maxPrecision]="2"
                (ionChange)="changeOverrideCasePrice($event)"
                (ionBlur)="inputBlur()"
                (ionFocus)="inputFocus()"
                [formControl]="priceOverrideInput"
              ></ion-input>
              <span
                *ngIf="
                  priceOverrideInput.errors?.pattern &&
                  !priceOverrideInput.errors?.numbersOnly
                "
                slot="error"
                >{{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.priceOverrideLimit'
                    | translate
                }}</span
              >
              <span
                *ngIf="priceOverrideInput.errors?.numbersOnly"
                slot="error"
                >{{
                  'i18n.inventory.inventoryWorksheet.inventoryItemModal.priceOverrideNumbersOnly'
                    | translate
                }}</span
              >
              <ion-label
                data-cy="inventory-item-modal-price-override-input-text"
                class="price-override-text"
              >
                /&nbsp;
                {{
                  (!inventoryItemModalOptions.catchWeightFlag
                    ? 'i18n.common.cs'
                    : 'i18n.inventory.inventoryWorksheet.card.lb'
                  ) | translate
                }}
              </ion-label>
            </ion-item>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="inventory-item-modal-desktop-tablet-cancel-button"
        [ngClass]="
          platformType === platformEnum.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="inventory-item-modal-desktop-tablet-next-button"
        class="select-modal-btn"
        [ngClass]="
          platformType !== platformEnum.mobile
            ? inventoryItemModalOptions.saveButtonIsDisabled ||
              customUnitInput.errors ||
              priceOverrideInput.errors
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : inventoryItemModalOptions.saveButtonIsDisabled ||
                customUnitInput.errors ||
                priceOverrideInput.errors
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-green-mobile-modal-button'
        "
        (click)="saveItemChanges()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<!-- PDP Overlay -->
<ion-modal
  [isOpen]="inventoryItemModalOptions?.isPDPOverlayOpen"
  class="full-page-modal"
  (ionModalDidDismiss)="closePDPOverlay()"
>
  <ng-template>
    <app-product-detail-modal
      class="ion-page"
      [platformType]="platformType"
      [selectedProductNumber]="inventoryItemModalOptions?.productNumber"
    ></app-product-detail-modal>
  </ng-template>
</ion-modal>
